module.exports = "/img/spartan_logo.png?c0f7e1e8d98c2041ef3a79fa3c49caa8";